Service = App.loadClass 'core::Angular/Service'

class exports.PlantingRxService extends Service
    constructor: (@http, @rootScope, @promise) ->
        @reset()


    # Calculates the weighted average population of the
    # individual area pops assigned
    averagePop: (use_temp = false) =>
        avg = 0
        total_acres = 0
        for pop in @data.populations
            continue if pop.truth_strip
            acres = parseFloat(pop.acres)
            total_acres += acres

            if use_temp
                pop_value = pop.temp_population
            else
                pop_value = pop.population

            avg += acres *  pop_value

        if total_acres > 0
            avg = avg / total_acres
            return Math.round(avg)
        else
            return ''


    setPopulation: (row, val, reeval_avg = true) =>
        if row.truth_strip
            strips = @getStripPolygons(row)
            for strip in strips
                strip.population = val
                strip.orig_population = val
                strip.temp_population = val
        else
            row.population = val
            row.orig_population = val
            row.temp_population = val

        if @data.truth_strips.length > 0 and reeval_avg
            row = @data.truth_strips[0]
            @setPopulation(
                truth_strip: true
                strip_id: row.strip_id
                real_strip_id: row.real_strip_id
            , @averagePop(true), false)


    getStripPolygons: (strip) =>
        list = _.filter(@data.populations, {
            truth_strip: 'Yes',
            truth_strip_id: strip.strip_id ? strip.truth_strip_id
        })

        if strip.real_strip_id?
            real = _.filter(@data.populations, {
                truth_strip: 'Yes',
                real_strip_id: strip.real_strip_id
            })
            list = list.concat(real)
        return _.uniq(list)

    # Takes an RxStorage object (instance of core::Storage) and uses
    # it to fetch the data from the backend, merging that with
    # any currently set information.
    loadFromStorage: (RxStorage) ->
        @data.crops_id = RxStorage.retrieve('crop')
        @data.crops_name = RxStorage.retrieve('crop_name')
        @data.fields_name = RxStorage.retrieve('field_name')
        @data.spp_id = RxStorage.retrieve('spp_id')
        @data.fsr_id = RxStorage.retrieve('fsr_id')
        @data.solver_variables = RxStorage.retrieve('solver_variables', {})
        @data.yield_goal = RxStorage.retrieve 'yield_goal'

        promise = @http.post('backend/grower/layers/planting-rx/ng-get-layer', RxStorage.except('spp')).then (result) =>
            @mergeOptions(result.data.data)
            return this

        return promise


    save: () ->
        @http.post 'backend/grower/layers/planting-rx/save', { layer: @asSaveOptions() }

    # Resets the rx data. This should be called once at the very beginning of
    # each Rx process, to ensure that all data is fresh for the new rx plan.
    reset: () =>
        @data = {
            id: null
            year: null
            spp_id: null
            crops_id: null
            layers_id: null
            fields_id: null
            crops_name: null
            fields_name: null
            previous_visual_layers: null
            cross_crop_operations_id: null
            want_truth_strips: false
            visual_layers: []
            solver_variables: {}
            planting_selections: []
            truth_strips: []
            populations: []
            populations_geom: []
            yield_goal: null
            planter: null
            refuge: null
            refuge_in_blocks: null
            productivity_index: null
            previous_calculation: null
        }

    # Returns the rx data as options to be passed to the solver. This is kind of messy,
    # like the `asSaveOptions` method is, but again; it's what the backend is working
    # with, so we'll do it.
    asSolverOptions: () =>
        if @data.want_truth_strips
            truth_strips = @_cleanedTruthStripsForSolver()
        else
            truth_strips = []

        layer = $.extend true, {}, {
            recalculate: true
            layer:
                id: @data.id
                visual_layers: @data.visual_layers
                fields_id: @data.fields_id
                spp_id: @data.spp_id
                cross_crop_operations_id: @data.cross_crop_operations_id
                crops_id: @data.crops_id
                solver_variables: @data.solver_variables
                hybrids: @_cleanedHybridsForSolver()
                truth_strips: truth_strips
                productivity_index: @data.productivity_index
                fsr_id: @data.fsr_id
        }

        if @data.yield_goal
            layer.layer.yield_goal = @data.yield_goal

        return layer


    mergeOptions: (options) =>
        $.extend(true, @data, options)


    compareSolverOptions: (new_options) =>
        old_options = @asSolverOptions()

        new_layer = @_getValuesForComparison(new_options)
        old_layer = @_getValuesForComparison(old_options)
        return _.isEqual(new_layer, old_layer)

    _getValuesForComparison: (options) =>
        # make a copy of the layer data, omitting anything we shouldn't compare
        layer = _.assign({}, options.layer, { cross_crop_operations_id: null })
        layer.visual_layers = layer.visual_layers.map (layer) ->
            return { id: layer.id, type: layer.type } # the name doesn't matter
        return layer

    # Builds up Rx data into a savable format. This is kind of ugly and messy
    # but it's the format the backend is working with right now. Hopefully
    # in the future, we can clean this up if we streamline the backend structure
    asSaveOptions: () =>
        request_data =
            id: @data.id
            layers_id: @data.layers_id
            fields_id: @data.fields_id
            machinery_planters_id: @data.planter.id
            planter_rows: @data.planter.number_of_rows
            crop_id: @data.crops_id
            year: @data.year
            spp_id: @data.spp_id
            base_layers: []
            cross_crop_operations_id: @data.cross_crop_operations_id
            hybrids: []
            populations: []
            truth_strips: []

            # solver vars
            target_pop: @data.solver_variables.target
            min_pop_diff: @data.solver_variables.min_pop_diff
            max_pop_diff: @data.solver_variables.max_pop_diff
            max_num_pops: @data.solver_variables.max_num_pops
            min_pop: @data.solver_variables.min_pop
            max_pop: @data.solver_variables.max_pop

        # Base Layers
        for layer in @data.visual_layers
            request_data.base_layers.push { id: layer.id, type: layer.type }

        # Hybrids
        request_data.hybrids = @getHybrids()

        # Populations!
        for pop in @data.populations_geom.getLayers()
            popd = $.extend({}, pop.feature.properties)
            popd.geom = pop.toGeoJSON().geometry
            request_data.populations.push popd

        for strip in @data.truth_strips
            request_data.truth_strips.push {
                geom: strip.poly.toGeoJSON().geometry
                strip_id: strip.strip_id
                real_strip_id: strip.real_strip_id
            }

        return request_data

    # Gets hybrids in the 'saveable' format
    getHybrids: () =>
        hybrids = []

        for hybrid in @data.planting_selections when hybrid.active
            hybrids.push {
                id: hybrid.brand.id
                hybrids_name: hybrid.brand.name
                hybrids_id: hybrid.brand.id
                products_id: hybrid.brand.products_id
                is_high_yield: hybrid.primary ? false
                is_low_yield: not hybrid.primary ? true
                is_refuge: false
                treatments_id: hybrid.treatment?.id
                treatments_name: hybrid.treatment?.name
                active: true
                units: hybrid.units
                acres: hybrid.acres
            }

        if @data.refuge?.active
            hybrids.push {
                id: @data.refuge.brand.id
                hybrids_name: @data.refuge.brand.name
                hybrids_id: @data.refuge.brand.id
                products_id: @data.refuge.brand.products_id
                is_high_yield: false
                is_low_yield: false
                is_refuge: true
                treatments_id: @data.refuge.treatment?.id
                treatments_name: @data.refuge.treatment?.name
                active: true
                units: @data.refuge.units
                acres: @data.refuge.acres
            }

        return hybrids


    selectedHybridIds: () ->
        ids = []
        for h in @data.planting_selections when h.active
            ids.push h.brand.id if h.brand?

        return ids

    # Handles getting list of hybrids prepped for sending a query to the backend.
    # Mostly, we just need to restructure the data a bit, and
    _cleanedHybridsForSolver: () =>
        cleaned = []
        for h in @data.planting_selections when h.active
            cleaned.push
                hybrids_id: h.brand?.id
                is_refuge: h.refuge
                active: true

        return cleaned

    # Handles cleaning up truth strips to be passed to the backend
    _cleanedTruthStripsForSolver: () =>
        cleaned = []
        for strip in @data.truth_strips
            if strip.poly_raw?
                cleaned.push turf.polygon(JSON.parse(strip.poly_raw).coordinates)
            else
                cleaned.push strip.poly.toGeoJSON()

        return cleaned


    # calculate the target population
    calculateTargetPop: =>

        # Grab the first product
        products = [@data.planting_selections[0].brand.id]

        # Grab the second, if it exists
        for elem in @data.planting_selections
            if not elem.primary and not elem.refuge and elem.active
                products.push(elem.brand.id)

        params =
            field_id: @data.fields_id
            fsr_id: @data.fsr_id
            spp_id: @data.spp_id
            year: @data.year
            products: products
            planter_id: @data.planter.id
            min_max_pop:
                min: @data.solver_variables.min_pop
                max: @data.solver_variables.max_pop
            is_rx: true
            rx_base_layers: @data.visual_layers
            max_num_pops: @data.solver_variables.max_num_pops

        return @http.post('backend/grower/layers/planting-rx/calculate-target-population', params).then((response) -> response.data).then (population) =>
            if $.isNumeric(population)
                @data.solver_variables.target = parseInt population
            return population
